import styled from "styled-components";

export default styled.div`
  background: ${(props) => props.theme.colors.ellipse_3};
  box-shadow: 4px 18px 27px rgba(78, 100, 236, 0.08);
  border-radius: 15px;
  padding: 15px;
  .header-cards {
    display: flex;
    gap: 16px;
    > p {
      display: none;
      font-style: normal;
      font-weight: 500;
      font-size: 12px;
      line-height: 45px;
      width: 100%;
      @media screen and (max-width: 769px) {
        display: block;
      }
    }
    .lp-staked-container {
      display: flex;
      flex-direction: column;
      gap: 5px;
      > p {
        display: none;
        color: ${(props) => props.theme.brandColor};
      }
      @media screen and (max-width: 769px) {
        p {
          font-size: 11px;
        }
      }
    }
    > div {
      flex: 1 1 247px !important;
      @media screen and (max-width: 769px) {
        flex: 1;
        flex-direction: row;
        justify-content: space-between;
        .bult-tfuel-lp-staked {
          order: 2;
        }
        :last-child {
          order: 1;
        }
      }
    }
    @media screen and (max-width: 769px) {
      .lp-staked-container > p {
        display: block;
      }
      .bult-tfuel-lp-staked {
        order: 2;
      }
    }
    @media screen and (max-width: 991px) {
      flex-wrap: wrap;
    }
  }
  .stake-tokens__footer {
    display: flex;
    align-items: center;
    gap: 15px;
    margin-top: 15px;
    .staking-rewards {
      min-height: 112px;
      position: relative;
      flex: 1 1 235px;
      padding: 11px;
      text-align: center;
      background: rgba(101, 43, 176, 0.69);
      border-radius: 10px;
      .title {
        font-style: normal;
        font-weight: 400;
        font-size: 10px;
        line-height: 15px;
        letter-spacing: 0.035em;
        color: ${(props) => props.theme.colors.ellipse_13};
      }
      > div:not(.title) {
        font-style: normal;
        font-weight: 500;
        line-height: 30px;
        color: ${(props) => props.theme.colors.ellipse_13};
        font-size: 14px;
        span {
          font-size: 20px;
          color: #fff;
          margin-inline-start: 6px;
        }
      }
      .error-message {
        font-size: 9px;
        width: 100%;
        position: absolute;
        top: 101%;
        right: 50%;
        transform: translateX(50%);
        color: #6d7d97;
        span {
          cursor: pointer;
        }
        @media screen and (max-width: 991px) {
          position: static;
        }
      }
    }
    .actions {
      flex: 1 1 247px;
      display: flex;
      flex-direction: column;
      gap: 7px;
      .back-button {
        cursor: pointer;
        font-weight: 400;
        font-size: 12px;
        line-height: 20px;
        border: 0;
        color: #fff;
        background: linear-gradient(90deg, #163193 0%, #122972 100%);
        border-radius: 6px;
        padding: 0px 9.71076px;
        transition: background 0.2s;
        :hover {
          transition: background 0.2s;
          background: #0d6bbd;
        }
      }
      > div {
        display: flex;
        gap: 5px;
        > * {
          flex: 1;
        }
      }
    }
    @media screen and (max-width: 991px) {
      flex-wrap: wrap;
    }
  }

  @media screen and (max-width: 769px) {
    background: unset !important;
    box-shadow: unset !important;
    padding: 0 !important;
    padding-bottom: 1rem !important;
  }
`;

const headerCardFooter = `
  min-height: 40px;
  display: flex;
  border-radius: 5px;
`;

export const BultTfuelLPStakedStyle = styled.div`
  background: ${(props) => props.theme.colors.ellipse_5};
  border: 1px solid ${(props) => props.theme.colors.ellipse_6};
  padding: 11px;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 11px;
  > div:first-child {
    display: flex;
    flex-direction: column;
    gap: 3px;
    p {
      color: ${(props) => props.theme.colors.ellipse_0};
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
    }
    span {
      color: #6d7d97;
      font-weight: 400;
      font-size: 13px;
      line-height: 20px;
    }
  }
  @media screen and (max-width: 769px) {
    flex-direction: row;
    justify-content: space-between;
    > div:first-child {
      justify-content: center;
      p {
        display: none;
      }
      span {
        font-size: 12px;
        min-width: 80px;
      }
    }
  }
  .input-container {
    position: relative;
    ${headerCardFooter}
    background: ${(props) => props.theme.colors.ellipse_7};
    button {
      font-weight: 400;
      font-size: 13px;
      line-height: 20px;
      cursor: pointer;
      margin: 4px;
      min-width: 58px;
      border: 0;
      border-radius: 4px;
      background: #163192;
      color: #fff;
    }
    input {
      width: 100%;
      color: ${({ theme }) => theme.colors.ellipse_1};
      border: 0;
      outline: none;
      background: transparent;
      flex: 1 1 auto;
      padding-inline-end: 9px;
    }
  }
  .user-address {
    ${headerCardFooter}
    background: ${(props) => props.theme.colors.ellipse_7};

    gap: 1rem;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    color: ${({ theme }) => theme.colors.ellipse_1};
    span {
      font-style: normal;
      font-weight: 400;
      font-size: 13px;
      line-height: 20px;
    }
  }
  .error-message {
    pointer-events: none;
    opacity: 0;
    position: absolute;
    background: #ff001a45;
    color: #f64e60;
    padding: 5px;
    border-radius: 5px;
    top: -75%;
    right: 0px;
    font-weight: 400;
    font-size: 11px;
    transition: all 0.3s ease-in-out;
    @media screen and (max-width: 769px) {
      top: -100%;
      right: -16px;
    }
  }

  .input-container input:focus + .error-message {
    transition: all 0.3s ease-in-out;
    pointer-events: default;
    opacity: 1;
  }
`;

export const StakedForStyle = styled.div`
  h3 {
    margin-top: 14px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: ${(props) => props.theme.colors.ellipse_20};
  }
  .duration-list {
    display: flex;
    gap: 15px;
    justify-content: space-evenly;
    margin-top: 9px;
    @media screen and (max-width: 991px) {
      flex-wrap: wrap;
    }
  }
`;

export const StakeButtonStyle = styled.button`
  cursor: pointer;
  width: 100%;
  border: 0;
  min-height: 32px;
  color: #fff;
  background: linear-gradient(90deg, #163193 0%, #122972 100%);
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: background 0.2s;
  :hover {
    transition: background 0.2s;
    background: #0d6bbd;
  }
  :disabled {
    transition: background 0.2s;
    pointer-events: none;
    background: #58709e;
  }
`;

export const StakingRewardsInfoStyle = styled.div`
  display: flex;
  align-items: center;
  /* margin-top: 7px; */
  height: 33px;

  .text {
    flex: 1;
    padding: 4px 15px;
    background-color: ${(props) => props.theme.colors.ellipse_38};
    height: 100%;
    display: flex;
    align-items: center;
    border-radius: 0 6px 6px 0;

    p {
      font-size: 10px;
      line-height: normal;
      text-align: start;
    }
  }
  .icon {
    border-radius: 6px 0 0 6px;
    padding: 0 8px;
    display: grid;
    place-items: center;
    background-color: ${(props) => props.theme.colors.ellipse_39};
    height: 100%;

    svg {
      width: 20px;
    }
  }
`;
